import React from 'react';
import './style.scss';
import NftImage from '../../../../general/nft/image';
import CreamCan from '../../../../../assets/images/common/creamCan';
import { API_FightNft } from 'shared';
import clsx from 'clsx';

interface Props {
  nft: API_FightNft;
  displayCream: boolean;
  className?: string;
}

const FightResultsNftImage = ({ nft, displayCream, className }: Props) => (
  <div className={clsx('fight-results-nft-image', className)}>
    <NftImage nft={nft} className='frn-image' />
    {displayCream && <CreamCan className='frn-cream-can' />}
  </div>
);

export default FightResultsNftImage;
